import { Wording } from '@/types';

export const FITNESS_WORDING_FR: Wording = {
  components_header_media_content: 'Entraînements',
  components_header_media_1: 'Pour les hommes',
  components_header_media_2: 'Pour les femmes',
  components_header_text1: 'Recettes',
  components_header_text2: 'Blog',
  components_header_members: 'Membres',
  hero_text: 'Gardez votre corps en forme et fort',
  hero_button_text: 'Commencez votre parcours de remise en forme',
  components_ressources_section_title: 'RESSOURCES',
  components_ressources_subheader_text:
    'Toutes les ressources dont vous avez besoin pour une vie saine',
  components_ressources_span_text:
    "Nourrissez votre bien-être : libérez une richesse de ressources pour une santé holistique et une vie saine, y compris des conseils d'experts sur la forme physique, la nutrition et les modes de vie durables.",
  components_ressources_card_1_title: 'Motivation',
  components_ressources_card_1_text:
    "De courtes bouffées de motivation pour des habitudes d'exercice durables.",
  components_ressources_card_2_title: 'Régime',
  components_ressources_card_2_text:
    'Conseils nutritionnels intelligents pour être en meilleure santé et plus fort.',
  components_ressources_link: 'Regarder des vidéos',
  components_notes_and_google_title_1: 'Entraînement physique',
  components_notes_and_google_title_2: 'Routine régulière',
  components_notes_and_google_title_3: 'Entretien du régime',
  components_review_google_text: 'Avis sur Google',
  media_content_section_title: 'ENTRAÎNEMENTS',
  media_content_section_subheader_text: 'Nos vidéos',
  text_media_1: 'Hommes',
  text_media_2: 'Femmes',
  media_content_section_button_more: 'Plus de vidéos',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articles et actualités',
  text2_section_button_more: "Plus d'articles",
  components_text1_section_title: 'RECETTES',
  components_text1_subheader_text:
    'Une alimentation saine pour votre vie active',
  components_text1_span_text:
    'Cuisinez de la vitalité : explorez un monde de remise en forme savoureuse avec nos recettes rapides et riches en nutriments.',
  components_text1_card_1_title: 'Commencez votre journée',
  components_text1_card_1_text:
    'Commencez votre journée du bon pied avec des options de petit-déjeuner riches en nutriments et en protéines.',
  components_text1_card_3_title: 'Des déjeuners riches en énergie',
  components_text1_card_3_text:
    "Découvrez des recettes de déjeuner délicieuses et pratiques conçues pour votre style de vie actif. Des salades colorées aux wraps riches en protéines, ces recettes vous permettent de rester concentré et plein d'énergie.",
  components_text1_card_2_title: 'Dîners de récupération',
  components_text1_card_2_text:
    'Explorez une variété de protéines maigres, de grains entiers et de légumes vibrants pour une fin de journée satisfaisante.',
  components_text1_link: 'Voir toutes les recettes',
  components_footer_text:
    'Élevez votre force, enflammez votre passion : votre salle de sport, votre transformation.',
  components_footer_info: 'Informations',
  components_footer_registration_number: "Numéro d'enregistrement",
  components_footer_legal: 'Légal',
  components_footer_terms: 'Termes et conditions',
  components_footer_privacy: 'politique de confidentialité',
  button_load_more: 'Charger plus',
  page_media_1_content_hero_text: 'Entraînements pour hommes',
  page_media_content_menu_all: 'Tous',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Dos',
  page_media_content_menu_chest: 'Poitrine',
  page_media_content_menu_legs: 'Jambes',
  page_media_content_menu_shoulders: 'Épaules',
  page_media_content_menu_abdominals: 'Abdominaux',
  page_media_2_content_hero_text: 'Entraînements pour femmes',
  page_text1_hero_text: 'Recettes',
  page_text1_section_title: 'Nutrition',
  page_text1_subheader_text: 'Recettes',
  page_text2_hero_text: 'Notre blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articles et actualités',
  enter_email_title: 'Veuillez entrer votre email pour continuer',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Entrer',
  components_login_success_text: 'Connexion réussie !',
  components_card_link_media_content: 'Regarder maintenant',
  components_card_link_text1_content: 'Voir la recette',
  components_card_link_text2_content: "Voir l'article",
  france: 'France',
  cyprus: 'Chypre',
};
